export default {
  "pl": {
    "issue": {
      "actions": {
        "collapse": "Zwiń problemy",
        "create_category": "Dodaj nową kategorię",
        "create_issue": "Utwórz zgłoszenie",
        "delete": "Usuń problem",
        "expand": "Rozwiń problemy",
        "update": "Problemy z aktualizacją"
      },
      "attributes": {
        "assignee": "Mandatariusz",
        "category": "Kategoria",
        "deadline": "Termin",
        "description": "Opis",
        "issue_list_type": "Typ listy problemów",
        "name": "Nazwa",
        "responsible": "Odpowiedzialny",
        "status": "Status",
        "statuses": {
          "completed": "Zakończone",
          "created": "Otwarty",
          "not_completed": "Nieukończony",
          "ongoing": "W toku"
        }
      },
      "edit_actions": {
        "edit_category": "Kategoria",
        "edit_deadline": "Termin ostateczny",
        "edit_responsible": "Odpowiedzialny",
        "edit_status": "Status"
      },
      "labels": {
        "after_care_page_title": "Twoje punkty",
        "count_edit": "Edytuj numer | Edytuj {count} zgłoszeń",
        "edit_issue": "Edytuj wydanie",
        "new": "Utwórz nowy numer",
        "no_issue_deadline": "Brak ustalonego terminu",
        "no_issues": "Brak problemów",
        "statusExplained": "Co oznacza każdy kolor statusu",
        "unit_issues_will_be_shown_here": "Wszystkie jednostki dołączone do listy problemów zostaną pokazane tutaj"
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "W momencie, gdy pracownik utworzy sprawy dla tej jednostki, pojawią się one tutaj.",
            "title": "Nie utworzono jeszcze spraw dla tej jednostki"
          }
        },
        "employees": {
          "none": {
            "subtitle": "Rozpocznij rejestrowanie, co należy naprawić lub poprawić",
            "title": "Utwórz zgłoszenie"
          },
          "overview": {
            "subtitle": "Aby rozpocząć, utwórz swój pierwszy numer wewnątrz jednostki",
            "title": "Tutaj pojawią się problemy utworzone we wszystkich Twoich jednostkach"
          }
        },
        "partners": {
          "none": {
            "subtitle": "W momencie, gdy będziesz miał przypisane do Ciebie problemy, pojawią się one tutaj.",
            "title": "Nie przypisano Ci żadnych problemów"
          }
        }
      },
      "validation": {
        "status_required": "Status jest wymagany"
      }
    }
  }
}
